import React from "react";
import CustomTextarea from "../../../components/Textarea/index.js";
import { AIUseCaseSummary } from "../../../entities/useCaseChat/UseCase.js";
import type { ChangeEvent } from 'react';
import { CtxGrid, CtxField } from "../../../components/UseCaseContextField/index.js";

interface UseCaseSummaryProps {
  formValues: AIUseCaseSummary;
  onInputChange: (field: keyof AIUseCaseSummary, value: string) => void;
  viewOnly?: boolean
}

const UseCaseSummary: React.FC<UseCaseSummaryProps> = ({
  formValues,
  onInputChange,
  viewOnly = true
}) => {
  if (viewOnly) {
    return (
      <CtxGrid>
        <CtxField label="Title" value={formValues.useCaseTitle} placeholder="No title provided" />
        <CtxField label="Brief AI Use Case Summary" value={formValues.useCaseSummary} placeholder="No summary provided" full />
        <CtxField label="Owner" value={formValues.useCaseOwner} placeholder="No owner provided" />
        <CtxField label="Department" value={formValues.department} placeholder="No department provided" />
        <CtxField label="Adoption Stage" value={formValues.adoptionStage} placeholder="No adoption stage provided" />
      </CtxGrid>
    );
  }

  return (
    <div className="space-y-6 pb-2">
      <CustomTextarea
        variant="plain"
        label="Title"
        value={formValues.useCaseTitle}
        onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
          if (typeof e === 'string') {
            onInputChange("useCaseTitle", e)
          } else {
            onInputChange("useCaseTitle", e.target.value)
          }
        }}
        placeholder="Enter title"
        className="w-full"
      />
      <CustomTextarea
        variant="plain"
        label="Brief AI Use Case Summary"
        value={formValues.useCaseSummary}
        onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
          if (typeof e === 'string') {
            onInputChange("useCaseSummary", e)
          } else {
            onInputChange("useCaseSummary", e.target.value)
          }
        }}
        placeholder="Enter brief AI use case summary"
        className="w-full overflow-y-auto"
      />
      <CustomTextarea
        variant="plain"
        label="Owner"
        value={formValues.useCaseOwner}
        onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
          if (typeof e === 'string') {
            onInputChange("useCaseOwner", e)
          } else {
            onInputChange("useCaseOwner", e.target.value)
          }
        }}
        placeholder="Enter owner"
      />
      <CustomTextarea
        variant="plain"
        label="Department"
        value={formValues.department}
        onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
          if (typeof e === 'string') {
            onInputChange("department", e)
          } else {
            onInputChange("department", e.target.value)
          }
        }}
        placeholder="Enter department"
      />
      <CustomTextarea
        variant="plain"
        label="Adoption Stage"
        value={formValues.adoptionStage}
        onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
          if (typeof e === 'string') {
            onInputChange("adoptionStage", e)
          } else {
            onInputChange("adoptionStage", e.target.value)
          }
        }}
        placeholder="Enter adoption stage"
        className="w-full"
      />
    </div>
  );
};

export default UseCaseSummary;